<template>
  <div class="kt-grid kt-grid--hor kt-grid--root">
    <KTHeaderMobile></KTHeaderMobile>
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <div
      class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"
    >
      <KTAside v-if="asideEnabled"></KTAside>
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper"
        id="kt_wrapper"
      >
        <KTHeader></KTHeader>
        <div
          class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
          id="kt_content"
        >
          <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          ></KTSubheader>
          <div
            class="kt-container kt-grid__item kt-grid__item--fluid"
            v-bind:class="{ 'kt-container--fluid': contentFluid }"
          >
            <transition name="fade-in-up">
              <router-view></router-view>
            </transition>
          </div>
        </div>
        <KTFooter></KTFooter>
      </div>
    </div>
    <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>
    <KTQuickPanel></KTQuickPanel>
    <KTScrollTop></KTScrollTop>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/views/theme/aside/Aside.vue";
import KTHeader from "@/views/theme/header/Header.vue";
import KTHeaderMobile from "@/views/theme/header/HeaderMobile.vue";
import KTFooter from "@/views/theme/footer/Footer.vue";
import HtmlClass from "@/common/htmlclass.service";
import KTSubheader from "@/views/theme/subheader/Subheader.vue";
import KTStickyToolbar from "@/views/partials/layout/StickyToolbar.vue";
import KTQuickPanel from "@/views/partials/layout/QuickPanel.vue";
import KTScrollTop from "@/views/partials/layout/ScrollTop";
import Loader from "@/views/partials/content/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";
import { APP_NAME } from "@/common/config.js";
import JwtService from "@/common/jwt.service";
import { CLEAR_AUTH, LOAD_AUTH, SET_AUTH } from "@/store/auth.module";
import * as moment from "moment";
// import subtractMinutes from "date-fns/subMinutes";
// import addSeconds from "date-fns/addSeconds";
// import differenceInMilliSeconds from "date-fns/differenceInMilliSeconds";
// import { parseISO } from "date-fns/fp";

export default {
  name: "Base",
  metaInfo: vm => {
    const title = vm ? vm.defaultTitle : "Welcome";

    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: title, // this.defaultTitle,
      // all titles will be injected into this template
      titleTemplate: "%s | " + APP_NAME
    };
  },
  components: {
    KTAside,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTQuickPanel,
    KTScrollTop,
    Loader
  },
  data: () => {
    return {
      prefix: null,
      refreshing: false
    };
  },
  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "kt-page--loading");

    // initialize html element classes
    HtmlClass.init();
  },
  mounted() {
    // check if current user is authenticated

    const route_prefix =
      this.getSection === "default" ? "" : this.getSection + "-";

    this.prefix = route_prefix;

    if (!this.isAuthenticated) {
      this.$store.dispatch(CLEAR_AUTH, this.getSection);
      this.goToLogin();
    } else {
      this.initSession();
    }

    // Simulate the delay page loading
    setTimeout(() => {
      // Remove page loader after some time
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "kt-page--loading");
    }, 2000);
  },
  methods: {
    initSession() {
      let tokenExpiryDate = moment(
        JwtService.getTokens(this.getSection, "tokensExpiry")
      );

      if (!tokenExpiryDate) {
        // return this.$router.push({ name: `${this.prefix}login` });
        return this.goToLogin();
      }

      let minutesBeforeExpiry = moment(tokenExpiryDate).subtract(5, "minutes"); //If the token has expired or will expire in the next 10 minutes

      // const now = new Date();

      // console.log(isAfter(now, tokenExpiryDate));
      // console.log(minutesBeforeExpiry.format());

      // if (isAfter(now, minutesBeforeExpiry)) {
      if (JwtService.isTokenExpired(this.getSection)) {
        //If the token has expired or will expire in the next 10 minutes
        // console.log("Token expired");
        return this.goToLogin(this.getSection);
      }

      // console.log(minutesBeforeExpiry.diff(new moment(), "days"));

      // console.log("Token Ok. Expiring at " + moment(tokenExpiryDate).format());
      setTimeout(this.refreshTokens, minutesBeforeExpiry.diff(new moment()));
    },
    refreshTokens() {
      var self = this;

      if (this.refreshing) {
        return;
      }

      this.refreshing = true;

      this.axios
        .post(`${this.getSection}/auth/refresh`, {
          refresh_token: JwtService.getTokens(this.getSection, "refresh_token")
        })
        .then(res => {
          this.refreshing = false;
          if ([200, 201].indexOf(res.status) !== -1) {
            const tokenExpiryDate = moment().add(
              res.data.expires_in,
              "seconds"
            );
            const minutesBeforeExpiry = moment(tokenExpiryDate).subtract(
              5,
              "minutes"
            );
            // subtractMinutes(tokenExpiryDate, 5);
            // const now = new Date();

            self.$store.dispatch(SET_AUTH, res.data);

            self.$store.dispatch(LOAD_AUTH);

            setTimeout(
              self.refreshTokens,
              minutesBeforeExpiry.diff(new moment())
            );
          }
        })
        .catch(() => {
          self.refreshing = false;
          self.goToLogin();
          // console.log("Failed");
        });
    },
    goToLogin() {
      this.$router.push({ name: `${this.prefix}login` });
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "getSection"
    ]),

    /**
     * Check if the page laoder is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !!this.layoutConfig("loader.enabled");
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      return !!this.layoutConfig("toolbar.display");
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    defaultTitle() {
      const sections = {
        default: "My Account",
        admin: "Administrator",
        affiliate: "Affiliates",
        vendor: "Vendors"
      };

      return sections[this.getSection];
    }
  }
};
</script>
